<template>
  <div class="content-wrapper">
    <app-overlay-loader v-if="preloader"/>
    <app-breadcrumb :page-title="pageTitle"
                    :directory="$t('datatables')"
                    :icon="'grid'"/>
    <template v-if="isScreeningScheduleExist">
      <div class="row">
        <div class="col-sm-4">
          <timer title="Limited Screening Timer"
                 :endingTime="this.screeningSchedule.limited_screening_due_date"
          />
        </div> <div class="col-sm-4">
          <timer title="Screening Timer"
                 :endingTime="this.screeningSchedule.complete_screening_due_date"
          />
        </div>
      </div>
    </template>
    <form ref="form"
          :data-url="addUrl"
          method="post">
      <template v-if="isApiLoadComplete">
        <app-tab :tabs="tabsHorizontal"
                 type="customize"/>
        <el-button class="btn btn-primary el-button--default float-right mt-sm-2"
                   @click="saveBtnHandler">
          Save
        </el-button>
      </template>
    </form>
  </div>
</template>
<script>
import {APPLICANT_INFO_UPDATE, SCREENING_USER_REGISTRATION} from "@/app/Config/ScreeningAppUrl";
import {FormMixin} from "@/core/mixins/form/FormMixin";
import {dateFormatter, saveBtnHandler} from '@Views/Screening/utility/common';
import {_yesOrNoList} from '@Views/Screening/utility/constant';
import {Candidate, Search} from "@Views/Screening/utility/apiAgent";
import {searchType} from "@Views/Screening/utility/enums";

export default {
  name: "CandidateDetail",
  mixins: [FormMixin],
  data() {
    return {
      pageTitle: "Candidate Detail",
      basicInfo: {},
      payrollInfo: {},
      addressInfo: [],
      applicantSearch: {},
      trainingInfo: [],
      candidateHistoryInfo: [],
      siaInfo: [],
      policyDeclarationInfo: {},
      gdprInfo: {},
      nextButton: false,
      active: 0,
      lastFormIndex: 8,
      preloader: false,
      registrationForm: {},
      activeIdCollection: [],
      licenses: [],
      tabsHorizontal: [
        {
          icon: "info",
          name: "Candidate Basic Info",
          component: "basic-info",
          permission: "",
          props: {}
        },
        {
          icon: "link",
          name: "Bank A/c Details",
          component: "payroll-info",
          permission: "",
          props: {}
        },
        {
          icon: "search",
          name: "Search",
          component: "candidate-detail-search",
          permission: "",
          props: {}
        },
        {
          icon: "link",
          name: "Addresses",
          component: "address-info",
          permission: "",
          props: {}
        },
        {
          icon: "link",
          name: "Training",
          component: "training-info",
          permission: "",
          props: {}
        },
        {
          icon: "link",
          name: "Previous History",
          component: "candidate-history",
          permission: "",
          props: {}
        },
        {
          icon: "link",
          name: "SIA Questionnaire",
          component: "sia-info",
          permission: "",
          props: {}
        },
        {
          icon: "link",
          name: "Upload Documents",
          component: "uploaded-documents-info",
          permission: "",
          props: {}
        },
        {
          icon: "link",
          name: "GDPR Notice",
          component: "gdpr-notice-info",
          permission: "",
          props: {}
        },
        {
          icon: "link",
          name: "Policy and Declaration",
          component: "policy-declaration-info",
          permission: "",
          props: {}
        },
      ],
      isApiLoadComplete: false,
      candidateId: 0,
      applicantArchiveId: 0,
      companyId: 0,
      addUrl: APPLICANT_INFO_UPDATE,
      isScreeningScheduleExist: false,
      screeningSchedule: {},
      yesOrNoList: _yesOrNoList,
      remainingTime: 0
    }
  },
  beforeUnmount() {
    clearInterval(this.timer);
  },

  mounted() {
    this.updateRemainingTime();
    this.timer = setInterval(this.updateRemainingTime, 1000);
    this.candidateId = Number(this.$attrs['candidate-id']);
    this.applicantArchiveId = Number(this.$attrs['applicant-archive-id']);
    this.companyId = Number(this.$attrs['company-id']);
    this.addUrl = `${APPLICANT_INFO_UPDATE}/${this.companyId}/${this.candidateId}`;
    this.getApplicantDetails(this.candidateId, this.applicantArchiveId);
    this.getApplicantSearch(this.candidateId);
    this.getApplicantSchedule(this.candidateId);
    this.licenses = (this.basic_info?.licenses && Array.isArray(this.basic_info?.licenses)) ? this.basic_info.licenses : []
  },
  computed: {
    formattedTime() {
      const seconds = Math.floor(this.remainingTime / 1000);
      const minutes = Math.floor(seconds / 60);
      const hours = Math.floor(minutes / 60);
      const days = Math.floor(hours / 24);

      if (days > 0) return `${days} day${days > 1 ? 's' : ''} left`;
      if (hours > 0) return `${hours} hour${hours > 1 ? 's' : ''} left`;
      if (minutes > 0) return `${minutes} minute${minutes > 1 ? 's' : ''} left`;
      return `${seconds} second${seconds > 1 ? 's' : ''} left`;
    }
  },
  methods: {
    updateRemainingTime() {
      const endTime = new Date(this.screeningSchedule.complete_screening_due_date).getTime();
      const now = Date.now();
      this.remainingTime = Math.max(0, endTime - now);
    },
    dateFormatter,
    saveBtnHandler,
    afterSuccess(response){
      this.$toastr.s(response.data.message);
    },afterError(response){
      this.$toastr.e(response.data.message);
    },
    getApplicantDetails(candidateId, applicantArchiveId = null) {
      this.preloader = true;
      Candidate.getCandidateById(candidateId, applicantArchiveId)
          .then(({data}) => {
            if (data?.applicant && Object.values(data?.applicant).length > 0) {
              this.setApiResponseIntoBasicInfoProps(data.applicant, 0);
              this.setApiResponseIntoPayrollProps(data.applicant?.applicant_payroll, 1);
              this.setApiResponseIntoAddressProps(data.applicant?.applicant_address, 3);
              this.setApiResponseIntoTrainingProps(data.applicant?.applicant_training, 4);
              this.setApiResponseIntoPreviousHistoryProps({
                employment: data.applicant?.applicant_employment,
                education: data.applicant?.applicant_education,
                selfEmployment: data.applicant?.applicant_self_employment,
                unEmployment: data.applicant?.applicant_unemployment
              }, 5);
              this.setApiResponseIntoSIAProps(data.applicant?.applicant_sia_detail, 6);
              this.setUploadDocumentProps(7);
              this.setApiResponseIntoGdprProps(data.applicant?.applicant_gdpr_detail, 8);
              this.setApiResponseIntoPolicyDeclrationProps(data.applicant?.applicant_policy_declaration, 9);
              this.getApplicantSchedule(data.applicant.screening_schedule);
              this.isApiLoadComplete = true;
              this.preloader = false;
            }
          });
    },
    setApiResponseIntoBasicInfoProps(applicant, index) {
      this.$set(this.basicInfo, 'full_name', applicant.full_name);
      this.$set(this.basicInfo, 'id', applicant.id);
      this.$set(this.basicInfo, 'forename', applicant.forename);
      this.$set(this.basicInfo, 'middle_name', applicant.middle_name);
      this.$set(this.basicInfo, 'surname', applicant.surname);
      this.$set(this.basicInfo, 'n_i_number', applicant.n_i_number);
      this.$set(this.basicInfo, 'gender', applicant.gender);
      this.$set(this.basicInfo, 'date_of_birth', applicant.date_of_birth);
      this.$set(this.basicInfo, 'title', applicant.title);
      this.$set(this.basicInfo, 'country_of_birth', applicant.country_of_birth);
      this.$set(this.basicInfo, 'town_of_birth', applicant.town_of_birth);
      this.$set(this.basicInfo, 'photo_id_match', applicant.photo_id_match);
      this.$set(this.basicInfo, 'nationality', applicant.nationality);
      this.$set(this.basicInfo, 'edbs_number', applicant.edbs_number);
      this.$set(this.basicInfo, 'contact_number', applicant.contact_number ?? '');
      this.$set(this.basicInfo, 'alternative_contact_no', applicant.alternative_contact_no ?? '');
      this.$set(this.basicInfo, 'email', applicant.email);
      this.$set(this.basicInfo, 'relationship', applicant.relationship);
      this.$set(this.basicInfo, 'next_of_kin', applicant.next_of_kin);
      this.$set(this.basicInfo, 'next_of_kin_contact_no', applicant.next_of_kin_contact_no ?? '');
      this.$set(this.basicInfo, 'is_sia_required', applicant.is_sia_required === 1 ? true : false);
      this.$set(this.basicInfo, 'sia_license_number', applicant.sia_license_number);
      this.$set(this.basicInfo, 'sia_license_type', applicant.sia_license_type);
      this.$set(this.basicInfo, 'sia_license_expiry', applicant.sia_license_expiry);
      this.$set(this.basicInfo, 'is_additional_license', applicant.is_additional_license === 1 ? true : false);
      this.$set(this.basicInfo, 'additional_sia_license_number', applicant.additional_sia_license_number);
      this.$set(this.basicInfo, 'additional_sia_license_type', applicant.additional_sia_license_type);
      this.$set(this.basicInfo, 'additional_sia_license_expiry', applicant.additional_sia_license_expiry);
      this.$set(this.basicInfo, 'share_code', applicant.share_code);
      this.$set(this.basicInfo, 'files', applicant.files);
      this.$set(this.basicInfo, 'share_code_start_date', applicant.share_code_start_date);
      this.$set(this.basicInfo, 'employee_picture', applicant.employee_picture);
      this.$set(this.basicInfo, 'is_visa_require_uk', applicant.is_visa_require_uk);
      this.$set(this.basicInfo, 'visa_type', applicant.visa_type);
      this.$set(this.basicInfo, 'biometric_residence_permit', applicant.biometric_residence_permit);
      this.$set(this.basicInfo, 'visa_expiry', applicant.visa_expiry);
      this.$set(this.basicInfo, 'date_of_entry_re_entry', applicant.date_of_entry_re_entry);
      this.$set(this.basicInfo, 'is_have_p45_or_p46', applicant.is_have_p45_or_p46);
      this.$set(this.basicInfo, 'copy_of_p45', applicant.copy_of_p45);
      this.$set(this.basicInfo, 'p46_detail', applicant.p46_detail);
      this.$set(this.basicInfo, 'is_other_employment', applicant.is_other_employment);
      this.$set(this.basicInfo, 'continue_other_employment', applicant.continue_other_employment);
      this.$set(this.basicInfo, 'is_leisure', applicant.is_leisure);
      this.$set(this.basicInfo, 'leisure_details', applicant.leisure_details);
      this.$set(this.basicInfo, 'is_criminal_record', applicant.is_criminal_record);
      this.$set(this.basicInfo, 'criminal_record_details', applicant.criminal_record_details);
      this.$set(this.basicInfo, 'is_bankruptcy', applicant.is_bankruptcy);
      this.$set(this.basicInfo, 'bankruptcy_details', applicant.bankruptcy_details);
      this.$set(this.basicInfo, 'is_days_shift_cant_work', applicant.is_days_shift_cant_work);
      this.$set(this.basicInfo, 'days_shift_cant_work_details', applicant.days_shift_cant_work_details);
      this.$set(this.basicInfo, 'is_holidays_commitment', applicant.is_holidays_commitment);
      this.$set(this.basicInfo, 'holidays_commitment_details', applicant.holidays_commitment_details);
      this.$set(this.basicInfo, 'is_own_vehicle', applicant.is_own_vehicle);
      this.$set(this.basicInfo, 'is_driving_license', applicant.is_driving_license);
      this.$set(this.basicInfo, 'driver_license_number', applicant.driver_license_number);
      this.$set(this.basicInfo, 'license_type', applicant.license_type);
      this.$set(this.basicInfo, 'license_issue_date', applicant.license_issue_date);
      this.$set(this.basicInfo, 'license_expiry_date', applicant.license_expiry_date);
      this.$set(this.basicInfo, 'statusable_type', applicant.statusable_type);
      this.$set(this.basicInfo, 'screening_status', applicant.screening_status);
      this.$set(this.basicInfo, 'licenses', applicant.licenses);
      this.$set(this.tabsHorizontal, index, {
        ...this.tabsHorizontal[index],
        props: {
          basic_info: this.basicInfo,
          yesOrNoList: this.yesOrNoList,
          isAdmin: true,
          candidateId: this.candidateId,
        }
      });
    },
    setApiResponseIntoPayrollProps(payroll, index) {
      if (payroll && Object.values(payroll).length > 0) {
        this.$set(this.payrollInfo, 'id', payroll.id);
        this.$set(this.payrollInfo, 'account_name', payroll.account_name);
        this.$set(this.payrollInfo, 'account_number', payroll.account_number);
        this.$set(this.payrollInfo, 'bank_name', payroll.bank_name);
        this.$set(this.payrollInfo, 'other_information', payroll.other_information);
        this.$set(this.payrollInfo, 'sort_code', payroll.sort_code);
        this.$set(this.payrollInfo, 'statusable_type', payroll.statusable_type);
        this.$set(this.payrollInfo, 'screening_status', payroll.screening_status);
      }
      this.$set(this.tabsHorizontal, index, {
        ...this.tabsHorizontal[index],
        props: {
          payroll_info: this.payrollInfo,
          isAdmin: true,
          candidateId: this.candidateId,
          emailAddress: this.basicInfo.email,
        }
      });
    },
    setApiResponseIntoAddressProps(address, index) {
      if (address && address.length > 0) {
        this.addressInfo = address;
      }
      this.$set(this.tabsHorizontal, index, {
        ...this.tabsHorizontal[index],
        props: {
          address_Info: this.addressInfo,
          screeningSchedule: this.screeningSchedule,
          dateFormatter: this.dateFormatter,
          isAdmin: true,
          candidateId: this.candidateId,
          emailAddress: this.basicInfo.email,
          onSaveBtn: this.saveBtnHandler,
        }
      });
    },
    addSocialMediaCheck(parentIndex, value) {
      this.applicantSearch[parentIndex].push(value)
    },
    setSearchComponentProps(index) {
      this.$set(this.tabsHorizontal, index, {
        ...this.tabsHorizontal[index],
        props: {
          candidate: this.basicInfo,
          address: this.addressInfo,
          applicantSearch: this.applicantSearch,
          socialMediaChecks: this.socialMediaChecks,
          onAddCheck: this.addSocialMediaCheck
        }
      });
    },
    setApiResponseIntoTrainingProps(training, index) {
      if (training && training.length > 0) {
        this.trainingInfo = training;
      }
      this.$set(this.tabsHorizontal, index, {
        ...this.tabsHorizontal[index],
        props: {
          yesOrNoList: _yesOrNoList,
          training_info: this.trainingInfo,
          dateFormatter: this.dateFormatter,
          isAdmin: true,
          candidateId: this.candidateId,
          emailAddress: this.basicInfo.email,
          onSaveBtn: this.saveBtnHandler,
        }
      });
    },
    setApiResponseIntoPreviousHistoryProps(previousHistory, index) {
      if (previousHistory.employment && previousHistory.employment.length > 0) {
        for (const employment of previousHistory.employment) {
          this.candidateHistoryInfo.push({...employment, type: 0});
        }
      }
      if (previousHistory.education && previousHistory.education.length > 0) {
        for (const education of previousHistory.education) {
          this.candidateHistoryInfo.push({...education, type: 1});
        }
      }
      if (previousHistory.selfEmployment && previousHistory.selfEmployment.length > 0) {
        for (const selfEmployment of previousHistory.selfEmployment) {
          this.candidateHistoryInfo.push({...selfEmployment, type: 2});
        }
      }
      if (previousHistory.unEmployment && previousHistory.unEmployment.length > 0) {
        for (const unEmployment of previousHistory.unEmployment) {
          this.candidateHistoryInfo.push({...unEmployment, type: 3});
        }
      }
      this.$set(this.tabsHorizontal, index, {
        ...this.tabsHorizontal[index],
        props: {
          yesOrNoList: _yesOrNoList,
          candidate_history_info: this.candidateHistoryInfo,
          dateFormatter: this.dateFormatter,
          isAdmin: true,
          candidateId: this.candidateId,
          emailAddress: this.basicInfo.email,
          onSaveBtn: this.saveBtnHandler,
        }
      });
    },
    setApiResponseIntoSIAProps(sia, index) {
      if (sia && sia.length > 0) {
        this.siaInfo = sia;
      }
      this.$set(this.tabsHorizontal, index, {
        ...this.tabsHorizontal[index],
        props: {
          sia_Info: this.siaInfo,
          isAdmin: true
        }
      });
    },
    setUploadDocumentProps(index) {
      this.$set(this.tabsHorizontal, index, {
        ...this.tabsHorizontal[index],
        props: {
          emailAddress: this.basicInfo.email,
          isAdmin: true,
          candidateId: this.candidateId,
        }
      });
    },
    setApiResponseIntoGdprProps(gdpr, index) {
      if (gdpr && Object.values(gdpr).length > 0) {
        this.$set(this.gdprInfo, 'id', gdpr.id);
        this.$set(this.gdprInfo, 'consent', gdpr.consent === 1 ? true : false);
        this.$set(this.gdprInfo, 'consent_date_time', gdpr.consent_date_time);
        this.$set(this.gdprInfo, 'special_category_data', gdpr.special_category_data === 1 ? true : false);
        this.$set(this.gdprInfo, 'statusable_type', gdpr.statusable_type);
        this.$set(this.gdprInfo, 'signature', gdpr.signature);
      }
      this.$set(this.tabsHorizontal, index, {
        ...this.tabsHorizontal[index],
        props: {
          gdpr_info: this.gdprInfo,
          isAdmin: true,
          candidateId: this.candidateId,
        }
      });
    },
    setApiResponseIntoPolicyDeclrationProps(policyDeclration, index) {
      if (policyDeclration && Object.values(policyDeclration).length > 0) {
        this.$set(this.policyDeclarationInfo, 'id', policyDeclration.id);
        this.$set(this.policyDeclarationInfo, 'applicant_screening', policyDeclration.applicant_screening === 1 ? true : false);
        this.$set(this.policyDeclarationInfo, 'criminal_background_check', policyDeclration.criminal_background_check === 1 ? true : false);
        this.$set(this.policyDeclarationInfo, 'declaration_by_applicant', policyDeclration.declaration_by_applicant === 1 ? true : false);
        this.$set(this.policyDeclarationInfo, 'financial_history', policyDeclration.financial_history === 1 ? true : false);
        this.$set(this.policyDeclarationInfo, 'equality', policyDeclration.equality === 1 ? true : false);
        this.$set(this.policyDeclarationInfo, 'equality_details', policyDeclration.equality_details);
        this.$set(this.policyDeclarationInfo, 'working_time_directive', policyDeclration.working_time_directive);
        this.$set(this.policyDeclarationInfo, 'statusable_type', policyDeclration.statusable_type);
      }
      this.$set(this.tabsHorizontal, index, {
        ...this.tabsHorizontal[index],
        props: {
          policy_declaration: this.policyDeclarationInfo,
          yesOrNoList: _yesOrNoList,
          isAdmin: true,
          candidateId: this.candidateId,
        }
      });
    },
    getApplicantSearch(candidate) {
      this.preloader = true;

      Search.getApplicantSearch(candidate)
          .then(({data}) => {
            this.$set(this.applicantSearch, searchType.SIA, data[searchType.SIA]);
            this.$set(this.applicantSearch, searchType.Credits, data[searchType.Credits]);
            this.$set(this.applicantSearch, searchType.RightToWork, data[searchType.RightToWork]);
            this.$set(this.applicantSearch, searchType.FinancialSanctions, data[searchType.FinancialSanctions]);
            this.$set(this.applicantSearch, searchType.socialMediaChecks, data[searchType.socialMediaChecks]);
            this.setSearchComponentProps(2);
            this.preloader = false;
          });

    },
    getApplicantSchedule(candidateSchedule) {
      if (candidateSchedule && Object.keys(candidateSchedule).length > 0) {
        this.isScreeningScheduleExist = true;
        this.screeningSchedule = {
          complete_screening_due_date: candidateSchedule.complete_screening_due_date,
          limited_screening_due_date: candidateSchedule.limited_screening_due_date,
          start_date: candidateSchedule.start_date,
          status: candidateSchedule.status,
          deployment_date : candidateSchedule.deployment_date,

        };

      }
    }
  }
}
</script>
